import { useEffect, useState } from "react";
import { FileBarChart, FileText, FileSpreadsheet } from "lucide-react";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, API_BASE, getToken } from "@/lib/api";

export default function Reportes() {
  const [locations, setLocations] = useState([]);
  const [equipment, setEquipment] = useState([]);
  const [f, setF] = useState({ location_id: "", equipment_id: "", date_from: "", date_to: "" });

  useEffect(() => {
    api.get("/locations").then(({ data }) => setLocations(data)).catch(() => {});
    api.get("/equipment").then(({ data }) => setEquipment(data)).catch(() => {});
  }, []);

  const buildUrl = (kind) => {
    const params = new URLSearchParams({ auth: getToken() });
    Object.entries(f).forEach(([k, v]) => { if (v) params.append(k, v); });
    return `${API_BASE}/reports/${kind}?${params.toString()}`;
  };

  const download = (kind) => window.open(buildUrl(kind), "_blank");

  return (
    <div>
      <PageHeader title="Reportes" subtitle="Genera reportes de controles de temperatura" />
      <div className="max-w-2xl rounded-2xl border border-slate-200 bg-white p-6">
        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <Label className="text-sm">Local</Label>
            <Select value={f.location_id || "all"} onValueChange={(v) => setF({ ...f, location_id: v === "all" ? "" : v })}>
              <SelectTrigger data-testid="report-location" className="mt-1 h-11"><SelectValue placeholder="Todos" /></SelectTrigger>
              <SelectContent><SelectItem value="all">Todos</SelectItem>{locations.map((l) => <SelectItem key={l.id} value={l.id}>{l.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-sm">Equipo</Label>
            <Select value={f.equipment_id || "all"} onValueChange={(v) => setF({ ...f, equipment_id: v === "all" ? "" : v })}>
              <SelectTrigger data-testid="report-equipment" className="mt-1 h-11"><SelectValue placeholder="Todos" /></SelectTrigger>
              <SelectContent><SelectItem value="all">Todos</SelectItem>{equipment.map((e) => <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label className="text-sm">Desde</Label><Input data-testid="report-from" type="date" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} className="mt-1 h-11" /></div>
          <div><Label className="text-sm">Hasta</Label><Input data-testid="report-to" type="date" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} className="mt-1 h-11" /></div>
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <Button data-testid="download-pdf-btn" onClick={() => download("pdf")} className="h-12 rounded-xl"><FileText className="mr-2 h-4 w-4" /> Generar PDF</Button>
          <Button data-testid="download-excel-btn" variant="outline" onClick={() => download("excel")} className="h-12 rounded-xl"><FileSpreadsheet className="mr-2 h-4 w-4" /> Exportar Excel</Button>
        </div>
      </div>
      <div className="mt-6 flex items-center gap-2 text-sm text-slate-400"><FileBarChart className="h-4 w-4" /> Los reportes incluyen KPIs, registros, incidencias y acciones correctivas.</div>
    </div>
  );
}
